import { useAdFree } from 'hooks/adFree'

import CustomAd from 'components/advertisments/CustomAd'
import Link from 'components/elements/Link'
import Icon from 'components/elements/Icon'

import styles from './inhouseFixedAd.module.scss'

const InhouseFixedAd = () => {
  const adFree = useAdFree()

  if (adFree) return null

  return (
    <>
      <div className={styles.desktopAdheasion} id="demo-fixed-ad">
        <Link href="https://archidekt.com/archidekt" className={styles.patreonLink}>
          <Icon name="patreon" /> Support us on Patreon to remove ads
        </Link>
      </div>

      <CustomAd className={styles.mobileAdheasion} />
    </>
  )
}

export default InhouseFixedAd
